import { ROUTES } from "@constants/routes";
import { STORAGE_KEYS } from "@constants/storageKeys";
import { StorageService } from "@services/StorageService";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  beforeLoad: () => {
    const hasSeenIntro = StorageService.getBoolean(STORAGE_KEYS.hasSeenIntro, false);
    throw redirect({ to: hasSeenIntro ? ROUTES.home : ROUTES.intro });
  },
});
